import React, { useCallback } from "react";
import {
  Button,
  ButtonGroup,
  Heading,
  Popup,
  PopupSection,
  Text,
} from "@flixbus/honeycomb-react";
import { Icon, IconDelete } from "@flixbus/honeycomb-icons-react";
import costPanelStyles from "../../CostPanel.module.scss";
import type { RemoveVariablesConfirmationPopupProps } from "./RemoveVariablesConfirmationPopup.types";

const titleId = "remove-variables-confirmation-title";
const contentId = "remove-variables-confirmation-content";

const RemoveVariablesConfirmationPopup: React.FC<
  RemoveVariablesConfirmationPopupProps
> = ({ active, isSaving, onConfirm, onCancel }) => {
  const handleClose = useCallback(() => {
    if (!isSaving) onCancel();
  }, [isSaving, onCancel]);

  return (
    <Popup
      active={active}
      aria-labelledby={titleId}
      aria-describedby={contentId}
      onOverlayClick={handleClose}
      loading={isSaving}
      extraClasses={costPanelStyles.confirmPopup}
    >
      <PopupSection type="icon">
        <Icon InlineIcon={IconDelete} size={6} aria-hidden="true" />
      </PopupSection>
      <PopupSection type="title">
        <Heading id={titleId} size={2} sectionHeader flushSpace>
          Removing variables
        </Heading>
      </PopupSection>
      <PopupSection type="content" id={contentId}>
        <Text>
          All values for the removed variable(s) will be erased. This cannot be
          undone.
        </Text>
      </PopupSection>
      <PopupSection type="actions">
        <ButtonGroup justify="center">
          <Button appearance="secondary" disabled={isSaving} onClick={onCancel}>
            Cancel
          </Button>
          <Button
            appearance="danger"
            disabled={isSaving}
            loading={isSaving}
            onClick={onConfirm}
          >
            Save formula
          </Button>
        </ButtonGroup>
      </PopupSection>
    </Popup>
  );
};

export default React.memo(RemoveVariablesConfirmationPopup);
